const es = {
    'Total': 'Total',
    'Go to checkout': 'Finalizar el pedido',
    'Coupon': 'Coupon',
    'Email': 'Correo Electrónico',
    'Proceed': 'Finalizar el pedido',
    'Select a shipping method to continue': 'Para continuar, seleccionar el método de envío',
    'Name': 'Nombre',
    'Last name': 'Apellido',
    'Street': 'Calle',
    'Zip code': 'Código Postal',
    'City': 'Ciudad',
    'Country': 'País',
    'State/Region': 'Provincia',
    'Change shipping address': 'Cambiar dirección de envío',
    'Change billing address': 'Cambiar dirección de facturación',
    'Change payment method': 'Cambiar forma de pago',
    'Edit': 'Editar',
    'Select shipping method': 'Seleccionar método de envío',
    'Select payment method': 'Seleccionar una forma de pago',
    'Additional services': 'Servicios adicionales',
    'Apply': 'Aplicar',
    'Sign in': 'Iniciar de sesión',
    'Password': 'Contraseña',
    'I want to receive the <span>INVOICE</span>': 'Quiero recibir la <span>Factura</span>',
    'Invoice requested': 'Factura solicitada',
    'Fiscal code': 'Código fiscal - CIF',
    'FC': 'CIF',
    'Quantity': 'Cantidad',
    'Loading': 'Cargando',
    'Remove': 'Eliminar',
    'Back': 'Atrás',
    '<strong>Add {tot}</strong> and we\'ll give you <strong>free</strong> shipping':
        '<strong>Añade {tot}</strong> y te <strong>regalamos</strong> los gastos de envío',
    'Shipping informations': 'Información de envío',
    'Shipping address': 'Dirección de envío',
    'Address': 'Dirección',
    'Company Name': 'Nombre de la empresa',
    'VAT Number': 'Código Cif o NIF / Número de IVA',
    'PEC Address': 'Dirección Pec',
    'SDI Code': 'SDI Code',
    'Are you sure you want to delete this item from cart': '¿Estás seguro de eliminar este artículo de tu carrito?',
    'Cart': 'Carrito',
    'Shipping': 'Envío',
    'Email and telephone number': 'Correo electrónico y número de teléfono',
    'Billing address': 'Dirección de facturación',
    'Billing address is the same as the shipping address':
        'La dirección de facturación coincide con la dirección de envío',
    'Selected address has invalid fields': 'La dirección seleccionada contiene campos incorrectos',
    'Continue as guest': 'Continuar como invitado',
    'or': 'o',
    'Recover password': 'Recuperar contraseña',
    'Account creation': 'Creación de la cuenta',
    'Continue': 'Continuar',
    'Please wait': 'Por favor, espere',
    'Close': 'Cerrar',
    'Order placed': 'Pedido realizado',
    'Send remainder': 'Enviar correo de recuperación de contraseña',
    'Password confirm': 'Confirmar contraseña',
    'Save address': 'Guardar dirección',
    'Street number': 'Número de casa + número de puerta + número de piso',
    'Select a payment method': 'Seleccionar una forma de pago',
    'Payment method': 'Forma de pago',
    'Error during registration': 'Error al registrarse',
    'We have sent you an email to reset your password. Click on the link you will find inside.':
        'Te hemos enviado un correo electrónico para restablecer tu contraseña. Haz clic en el enlace correspondiente.',
    'Service unavailable, retry later': 'Error durante la solicitud, por favor inténtelo de nuevo en breve',
    'Error, try to logout and login back to proceed with checkout': 'Error, intenta cerrar sesión y volver a iniciar sesión para continuar con el pago',
    'Ordered products': 'Productos pedidos',
    'No shipping methods available': 'Ningún método de envío disponible',
    'We\'re unable to send the password reset email':
        'No se ha podido enviar el correo electrónico para restablecer la contraseña. Por favor, comprueba el correo electrónico que has introducido',
    'Do you have a promotional code?': '¿Tienes un código descuento?',
    'Insert the code': 'Introducir código',
    'Order summary': 'Resumen del pedido',
    'VAT': 'IVA',
    'Sign up': 'Regístrate',
    'Already registered on': 'Ya estás registrado en',
    'Don\'t have an account yet?': '¿Todavía no tienes cuenta?',
    'First time on': '¿Primera vez en',
    'Create your personal account.': 'Crea tu cuenta personal',
    'Your Password': 'Tu contraseña',
    'Your name': 'Tu nombre',
    'Your last name': 'Tu apellido',
    'Choose a password': 'Elegir una contraseña',
    'Your email': 'Tu correo',
    'Or sign in with your email address': 'O inicia sesión con tu correo electrónico',
    'Sign in with your email address': 'Inicia la sesión con tu correo electrónico',
    'Do you already have an account?': '¿Ya tienes una cuenta?',
    'Create an account': 'Crear una cuenta',
    'Sign up with your email address': 'Regístrate con tu correo electrónico',
    'Continue shopping': 'Seguir comprando',
    'Your cart is empty': 'Tu carrito está vacío',
    'product': 'producto',
    'products': 'productos',
    'Shipping included': 'Gastos de envío incluidos',
    'Choose a shipping address': 'Elegir una dirección de envío',
    'There aren\'t shipping methods for this address, insert/select another one':
        'No hay métodos de envío para esta dirección, por favor introduzca/seleccione otro',
    'Attention, the cost of shipments has been updated': 'Atención, se han actualizado los gastos de envío',
    'Select an address': 'Selecciona una dirección',
    'Save new address to proceed': 'Guardar la nueva dirección para continuar',
    'Create new address to proceed': 'Crear una nueva dirección para continuar',
    'Insert a valid email address to proceed': 'Introduzca un correo electrónico válido para continuar',
    'Accept all agreements to proceed': 'Aceptar los terminos para continuar',
    '<a href="{link}">Edit it</a> or insert/select another one':
        '<a href="{link}"> Editar </a> o insertar/seleccionar otro',
    'Phone number': 'Teléfono móvil',
    'Telephone number': 'Número de teléfono',
    'Contact details': 'Contacto',
    'Address details': 'Dirección',
    'Add new address': 'Añadir nueva dirección',
    'Enter Company Name': 'Introduzca el nombre de la empresa',
    'Enter VAT Number': 'Introduzca tu código CIF o NIF',
    'Enter PEC address': 'Introduzca tu correo electrónico PEC',
    'Enter your SDI code': 'Enter your SDI code',
    'Please check your order.': 'Por favor, revisa tu pedido',
    'By confirming your order, you accept our general terms and conditions as well as the information on security and data protection on www.passionebeauty.com.':
        'Al confirmar tu pedido, se aceptan nuestras condiciones generales, así como la información sobre seguridad y protección de datos que figura en la página web.',
    'Loading payment form, please wait': 'La solicitud de pago se está cargando, por favor espere',
    'Available for shipment': 'Disponible para el envío',
    'I understand': 'Entiendo',
    'Forgot Your Password?': '¿Olvidaste tu contraseña?',
    'Step {step} of {steps}': 'Paso {step} de {steps} pasos',
    'This field is mandatory': 'Campo obligatorio',
    'Enter at least one of the two fields': 'Introduzca al menos uno de los dos campos',
    'Sales conditions': 'Condiciones de venta',
    'Ops! The payment for your last order <strong>was unsuccessful and will be automatically deleted within 20 minutes</strong>. To try again click below and the procedure will start again.':
        'El pago de tu último pedido se ha procesado correctamente y se cancelará automáticamente en 20 minutos. Para volver a intentarlo, haga clic a continuación y el procedimiento se iniciará de nuevo. Tengas en cuenta que, si has intentado utilizar una tarjeta regalo durante tu pedido, deberás esperar a que el pedido se cancele (20 minutos) antes de poder volver a utilizarla.',
    'Do you prefer to return to visit the site and place your order later?':
        '¿Prefieres echar un vistazo a la página web y realizar tu pedido más tarde?',
    'Reorder': 'Volver a pedir',
    'Your last order has not been completed. If you want to add last order\'s items click on "Add" button':
        'Tu pedido anterior no se ha finalizado. Si deseas añadir productos de tu pedido anterior, haz clic en el botón "Añadir"',
    'Add': 'Añadir',
    'Check the phone number: <strong>it must be a valid mobile phone</strong>.':
        'Revisa el número de teléfono: debe ser un teléfono móvil español',
    'Change telephone number': 'Cambiar número de teléfono',
    'Telephone must be a valid italian mobile phone': 'El teléfono debe ser un teléfono móvil válido',
    'Do you have a gift card?': '¿Tienes una tarjeta regalo?',
    'Verify gift card': 'Comprobar la tarjeta regalo',
    'Current balance': 'Saldo actual',
    'The gift card is invalid or empty. Please check the gift card and try again':
        'La tarjeta regalo no es válida o está vacía. Comprueba la tarjeta regalo e inténtelo de nuevo',
    'Gift card applied': 'Tarjeta regalo añadida',
    'Gift card was removed because the total amount is too low':
        'Tarjeta regalo eliminada porque su valor supera el importe de la compra. Añadir más productos para utilizar la tarjeta regalo',
    'No payment information required': 'No se requiere información de pago',
    'Sign in with {social}': 'Iniciar sesión con {social}',
    'Added to wishlist': 'Añadido a la lista de deseos',
    'Do you want to add the product to your wish list before removing it?':
        'Quieres añadir el producto a tu lista de deseos antes de eliminarlo?',
    'Add to wishlist': 'Añadir a la lista de deseos',
    'Please note! One or more products cannot be ordered. Please check the products highlighted in red in your shopping cart.':
        '¡Tenga en cuenta! No se pueden pedir uno o más productos. Por favor revise los productos resaltados en rojo en su carrito de compras.',
    'Payment': 'Pago',
    'Check': 'Revisar',
    'VAT {taxPercent}% included': '{taxPercent}% IVA incluido',
    'Descuento (Devolución del IVA)': 'Devolución del IVA',
    'Select': 'Seleccionar',
    'Change': 'Cambiar',
    'Pickup Point': 'Punto de recogida',
    'Change pickup point': 'Cambiar punto de recogida',
    'You have selected a different country, please choose your prefered shipping method':
        'Ha seleccionado un país diferente, elija su método de envío preferido',
    'Yes': 'Sí',
    'No': 'No',
    'Choose whether to have the invoice or not to proceed': 'Elige si quieres tener la factura o no para proceder',
    'Please enter your email address below to receive a password reset link.':
        'Por favor introduce tu dirección de correo electrónico para recibir un enlace de restablecimiento de contraseña.',
    'To see your cart, first log in to your Passione Beauty account.':
        'Para ver su carrito, primero inicie sesión en su cuenta Passione Beauty.',
    'If you need further assistance.': 'Si necesita más ayuda.',
    'Write to us': 'Escríbenos',
    'Registration completed successfully': 'Registro completado con éxito',
    'View and track order': 'Visualizar y rastrear el pedido',
    'By completing this order you can earn {points}': 'Al completar este pedido puedes ganar {points}',
    'If you are registered with the Passione Club, with this order you will get {points}':
        'Si estás registrado en el Club Passione, con este pedido obtendrás {points}',
    '{points} - completing order': '{points} - completando el pedido',
    '{points} - bonus for in-app purchase': '{points} - bonificación por compra dentro de la aplicación',
    'Used up': 'Agotado',
    'Sorry, we can\'t apply this service right now': 'Lo sentimos, no podemos aplicar este servicio en este momento.',
    'There is already an account with this email address. If you are sure that it is your email address, <a href="{url}">click here</a> to get your password and access your account.':
        'Este correo ya tiene una cuenta activa, si olvidaste tu contraseña la puedes recuperar dando <a href="{url}">clik aquí</a>.',
    'If you\'d like to use a Coupon, please remove the Gift Card first':
        'Si desea utilizar un cupón, retire primero la tarjeta de regalo',
    'Pay with a saved credit card': 'Pagar con una tarjeta de crédito guardada',
    'Expiration': 'Vencimiento',
    'Pay with a new credit or debit card': 'Pague con una nueva tarjeta de crédito o débito',
    'Save credit card (one click payment)': 'Guardar tarjeta de crédito (pago con un clic)',
    'Sign up with {social}': 'Registrarse con {social}',
    'Registering with Facebook is very fast. There is no need to remember other passwords - no commitments for the brain. Don\'t worry, we won\'t share any information about you and we won\'t post anything on your behalf.':
        'Registrarse en Facebook es muy rápido. No hay necesidad de recordar otras contraseñas, no hay compromisos para el cerebro. No te preocupes, no compartiremos ninguna información sobre tí y no publicaremos nada en tu perfil.',
    'Shipping Country': 'País de envío',
    'Removing': 'Eliminando',
    'Free shipping': 'Envío gratuito',
    'Save for future use': 'Guardar para uso futuro',
    'This order will be associated to your sales code:': 'Este pedido estará asociado a su código de venta:',
    'Delete card': 'Eliminar tarjeta',
    'Card deleted.': 'Tarjeta eliminada.',
    'Use another card or another payment method to continue.':
        'Para continuar, utiliza otra tarjeta u otro método de pago.',
    'Try entering your card details again or use another payment method to continue.':
        'Para continuar, vuelve a introducir los datos de la tarjeta o utiliza otro método de pago.',
    'There was an error deleting your card, please try again later':
        'Se produjo un error al eliminar tu tarjeta, inténtalo nuevamente más tarde',
    'Or register with your e-mail address': 'O regístrate con tu dirección de correo electrónico',
    'ReCaptcha validation failed, please try again': 'La validación de ReCaptcha falló, inténtelo de nuevo',
    'This site is protected by reCAPTCHA and the Google <a href="{privacyPolicyLink}">Privacy Policy</a> and <a href="{termsOfServiceLink}">Terms of Service</a> apply.':
        'Este sitio está protegido por reCAPTCHA y se aplican la <a href="{privacyPolicyLink}">Política de Privacidad</a> y los <a href="{termsOfServiceLink}">Términos de Servicio</a> de Google.',
    'Forgot Password?': '¿Has olvidado tu contraseña?',
    'Conditions of sale for training courses': 'Condiciones de venta de cursos de formación',
    'Previously it was: {omnibusPrice} -{omnibusPercentage}': 'Antes: {omnibusPrice} -{omnibusPercentage}',
    'How to read prices': 'Detalle de los precios',
    'Here is an example to understand what the prices you find mean':
        'A continuación se muestra un ejemplo para aclarar el significado de los precios',
    'This is the original price of the item without discounts (list price)':
        'Este es el precio original del artículo sin descuentos (precio de catálogo)',
    'This is the currently active discount on the item applied to the list price price expressed as a percentage':
        'Este es el descuento actualmente activo en el producto aplicado al precio de catálogo y expresado en porcentaje',
    'This is the current item price with discount applied and VAT included':
        'Este es el precio actual del artículo con descuento aplicado e IVA incluido',
    'This is the lowest price the item had in the last 30 days before it was discounted':
        'Este es el precio más bajo que tuvo el artículo durante los 30 días anteriores al descuento',
    'Telephone prefix': 'Prefijo telefónico',
    'Telephone without prefix': 'Teléfono sin prefijo',
    'Choose whether you have a VAT number or are a small business':
        'Elige si tienes un número de IVA o eres una pequeña empresa',
    'Card': 'Tarjeta de crédito',
};

export default es;
export const esValidation = {
    name: 'es',
    messages: {
        '_default': (e: any) => {
            return `El valor del campo ${e} no es válido.`;
        },
        'after': (e: any, n: any) => {
            return `El campo ${e} debe estar después de ${n[0]}.`;
        },
        'alpha': (e: any) => {
            return `El campo ${e} sólo puede contener caracteres alfabéticos.`;
        },
        'alpha_dash': (e: any) => {
            return `El campo ${e} puede contener caracteres alfanuméricos, así como guiones y guiones bajos.`;
        },
        'alpha_num': (e: any) => {
            return `El campo ${e} sólo puede contener caracteres alfanuméricos.`;
        },
        'alpha_spaces': (e: any) => {
            return `El campo ${e} sólo puede contener caracteres alfanuméricos, así como espacios.`;
        },
        'before': (e: any, n: any) => {
            return `El campo ${e} debe estar antes de ${n[0]}.`;
        },
        'between': (e: any, n: any) => {
            return `El campo ${e} debe estar entre ${n[0]} y ${n[1]}.`;
        },
        'confirmed': (e: any, n: any) => {
            return `El campo ${e} no coincide con ${n[0]}.`;
        },
        'credit_card': (e: any) => {
            return `El campo ${e} no es válido.`;
        },
        'date_between': (e: any, n: any) => {
            return `El ${e} debe estar entre ${n[0]} y ${n[1]}.`;
        },
        'date_format': (e: any, n: any) => {
            return `El campo ${e} debe tener el formato ${n[0]}.`;
        },
        'decimal': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-void, no-param-reassign
            void 0 === n && (n = []);
            let r = n[0];
            // eslint-disable-next-line no-return-assign
            return (
                // eslint-disable-next-line no-void
                void 0 === r && (r = '*'),
                    `El campo ${e} debe ser numérico y puede contener ${r && r !== '*' ? ` ${r}` : ''} decimales.`
            );
        },
        'digits': (e: any, n: any) => {
            return `El campo ${e} debe ser numérico y contener exactamente ${n[0]} dígitos.`;
        },
        'dimensions': (e: any, n: any) => {
            return `El campo ${e} debe ser ${n[0]} x ${n[1]}.`;
        },
        'email': (e: any) => {
            return `El campo ${e} debe ser una dirección de correo electrónico válida.`;
        },
        'excluded': (e: any) => {
            return `El campo ${e} debe tener un valor válido.`;
        },
        'ext': (e: any) => {
            return `El campo ${e} debe ser un archivo válido.`;
        },
        'image': (e: any) => {
            return `El campo ${e} debe ser una imagen.`;
        },
        'included': (e: any) => {
            return `El campo ${e} debe tener un valor válido.`;
        },
        'ip': (e: any) => {
            return `El campo ${e} debe ser una dirección IP válida.`;
        },
        'length': (e: any, n: any) => {
            const r = n[0];
            const o = n[1];
            return o
                ? `La longitud del campo ${e} debe estar comprendida entre ${r} y ${o}.`
                : `La longitud del campo ${e} debe ser ${r}.`;
        },
        'max': (e: any, n: any) => {
            return `El campo ${e} no puede tener más de ${n[0]} caracteres.`;
        },
        'c': (e: any, n: any) => {
            return `El campo ${e} debe ser menor o igual que ${n[0]}`;
        },
        'mimes': (e: any) => {
            return `El campo ${e} debe tener un tipo de archivo válido.`;
        },
        'min': (e: any, n: any) => {
            return `El campo ${e} debe tener al menos ${n[0]} caracteres.`;
        },
        'min_value': (e: any, n: any) => {
            return `El campo ${e} debe ser mayor o igual que ${n[0]}.`;
        },
        'numeric': (e: any) => {
            return `El campo ${e} sólo puede contener caracteres numéricos.`;
        },
        'regex': (e: any) => {
            return `El campo ${e} no tiene un formato válido.`;
        },
        'required': (e: any) => {
            return `El campo ${e} es obligatorio.`;
        },
        'size': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            return `El campo ${e} debe ser menor que ${((e) => {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const n = 1024;
                // eslint-disable-next-line no-cond-assign, no-param-reassign
                const r = (e = Number(e) * n) === 0 ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / n ** r).toFixed(2));
                const v = 1 * f;
                return `${v.toFixed(2)} ${['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][r]}`;
            })(n[0])}.`;
        },
        'url': (e: any) => {
            return `El campo ${e} no es una URL válida.`;
        },
        'validate-piva-cf': () => {
            return 'NIF / CIF no válido';
        },
        'validate-regionid': () => {
            return 'El campo Provincia es obligatorio';
        },
        'validate-password-wf': () => {
            return 'La longitud mínima de este campo debe ser igual o superior a {1} caracteres. Se ignorarán los espacios iniciales y finales. Comprueba que existen al menos 2 de las 3 condiciones siguientes: al menos una letra mayúscula, al menos un número, al menos un carácter especial';
        },
        'validate-password-wf-length': () => {
            return 'La longitud mínima de este campo debe ser igual o superior a {1} caracteres. Se ignorarán los espacios iniciales y finales';
        },
        'validate-password-wf-character': () => {
            return 'Comprueba que se cumplen al menos 2 de las 3 condiciones siguientes: al menos una letra mayúscula, al menos un número y al menos un carácter especial';
        },
        'validate-length': (e: any) => {
            return `Atención el campo ${e} debe tener {1} caracteres.`;
        },
        'validate-fiscal-code': () => {
            return 'El código fiscal debe tener exactamente 9 caracteres';
        },
        'validate-telephone-without-prefix': () => {
            return 'Por favor especifique un teléfono válido, no debe contener el prefijo (por ejemplo, +34).';
        },
        'validate-foreign-country-telephone-without-prefix': () => {
            return 'Por favor especifique un teléfono válido, no debe contener el prefijo (por ejemplo, +34).';
        }
    },
    attributes: {}
};
